import { render, staticRenderFns } from "./IbSelect.vue?vue&type=template&id=2087e095"
var script = {}
import style0 from "./IbSelect.vue?vue&type=style&index=0&id=2087e095&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports